module.exports = __webpack_public_path__ + "static/media/SLIDERS-COVID2-600.03fa2acb.png";